export var NAVIGATE_TO = '@@router5/NAVIGATE';
export var CANCEL_TRANSITION = '@@router5/CANCEL';
export var TRANSITION_ERROR = '@@router5/TRANSITION_ERROR';
export var TRANSITION_SUCCESS = '@@router5/TRANSITION_SUCCESS';
export var TRANSITION_START = '@@router5/TRANSITION_START';
export var CLEAR_ERRORS = '@@router5/CLEAR_ERRORS';
export var CAN_DEACTIVATE = '@@router5/CAN_DEACTIVATE';
export var CAN_ACTIVATE = '@@router5/CAN_ACTIVATE';


//////////////////
// WEBPACK FOOTER
// ./~/redux-router5/dist/es/lib/actionTypes.js
// module id = ./node_modules/redux-router5/dist/es/lib/actionTypes.js
// module chunks = 0